{each, extend, find, map, omit} = require 'underscore'

mergeRedemptionLocationInfo = (optionIdMap, redemptionLocationMap) ->
  return {} unless optionIdMap

  for id, shippingOption of optionIdMap
    optionWithRedemptionLocation = find shippingOption, (option) ->
      option.redemptionLocations?.length
    each optionWithRedemptionLocation?.redemptionLocations, (location) ->
      extend location, omit(redemptionLocationMap[location.id], 'id', 'uuid')

  optionIdMap

getBuyUrlWithShippingOptionData = (buyUrl, shippingOptionData) ->
  params = []

  for key, value of shippingOptionData
    params.push("#{key}=#{value}") if value

  "#{buyUrl}#{if buyUrl.indexOf('?') > -1 then '&' else '?'}#{params.join '&'}"

getRedemptionLocationsFromResponse = (response={}, variantId) ->
  {optionIdMap, redemptionLocationMap} = response
  return [] unless optionIdMap and redemptionLocationMap

  shippingOptions = optionIdMap[variantId]

  optionWithRedemptionLocation = find shippingOptions, (option) ->
    option.redemptionLocations?.length

  return [] unless optionWithRedemptionLocation?.redemptionLocations?.length

  map optionWithRedemptionLocation.redemptionLocations, (location) ->
    extend {}, location, omit(redemptionLocationMap[location.id], 'id', 'uuid')

module.exports = {mergeRedemptionLocationInfo, getBuyUrlWithShippingOptionData, getRedemptionLocationsFromResponse}



// WEBPACK FOOTER //
// ./modules/goods_local_supply_v2/common/helpers.coffee